import React from 'react';
import WorkLogItem from './workLogItem'; // Adjust path as needed

const WorkLogList = ({ logs, loading }) => {
  if (loading) return <div className="text-sm text-gray-500">Loading work logs...</div>;
  if (!logs?.length) return <div className="text-sm text-gray-500">No work logs yet.</div>;

  return (
    <div className="">
      {logs.map((log) => (
        <WorkLogItem key={log.log_id || log.id} log={log} />
      ))}
    </div>
  );
};

export default WorkLogList;